import { copy } from "../copy";
import Icon, { type IconName } from "../components/Icon";

export type DashboardTab = "profile" | "photo" | "inbox" | "withdrawals";

const TABS: { key: DashboardTab; icon: IconName }[] = [
  { key: "profile", icon: "user" },
  { key: "photo", icon: "quillPen" },
  { key: "inbox", icon: "inboxArchive" },
  { key: "withdrawals", icon: "wallet" },
];

export default function DashboardTabs({
  active,
  onChange,
  unread,
}: {
  active: DashboardTab;
  onChange: (tab: DashboardTab) => void;
  unread: number;
}) {
  const t = copy.dashboard;
  return (
    <div
      role="tablist"
      aria-label={t.sections}
      className="bf-no-scrollbar flex gap-1.5 overflow-x-auto rounded-full border border-ground-edge bg-ground-raised p-1.5"
    >
      {TABS.map((tab) => {
        const isActive = active === tab.key;
        const count = tab.key === "inbox" ? unread : 0;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            id={`tab-${tab.key}`}
            aria-selected={isActive}
            aria-controls={`panel-${tab.key}`}
            onClick={() => onChange(tab.key)}
            className={`bf-focusable flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors ${
              isActive ? "bg-money text-ground" : "text-chrome-dim hover:text-chrome"
            }`}
          >
            <Icon name={tab.icon} className="text-base" />
            {t.tabs[tab.key]}
            {count > 0 && (
              <span
                data-testid="unread-count"
                className={`bf-tabular flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] ${
                  isActive ? "bg-ground text-money" : "bg-gold text-ground"
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
